<script>
    import R, {LOADER} from "../lib/requests";
    import passportsStore from "../stores/passportsStore";
    import {PASSPORT_STATUS} from "../lib/constants";
    import Modal from '../components/modal/Modal.svelte';
    import {copyObject, formatDate, passportStatus} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts";

    export let passportId = null;
    export let closeCallback;

    let passports = null;
    let showFail = false;

    const toggleFail = () => {
        showFail = !showFail;
    }

    const load = () => {

        const onSuccess = result => {
            passports = result;
            passports.status = ~~passports.status;
        };

        const onFailure = err => {
        };

        R.handle(R.passport.details, passportId, onSuccess, onFailure, LOADER.POPUP);
    };

    const onDelete = () => {
        let prompt = "";
        if (passports.order) {
            prompt = `Να γίνει διαγραφή των διαβατηρίων της παραγγελίας <b>${passports.order.ref_id}</b> από το μέλος <b>${passports.member.lastname} ${passports.member.firstname}</b>;`;
        } else {
            prompt = `Να γίνει διαγραφή των διαβατηρίων από το μέλος <b>${passports.member.lastname} ${passports.member.firstname}</b>;`
        }
        Alert.delete("Διαγραφή διαβατηρίων", prompt, deletePassports);
    }

    const deletePassports = () => {
        const onSuccess = result => {
            Notifier.showMessage("Τα διαβατήρια διαγράφτηκαν");
            $passportsStore.changed = true;
            close(passports);
        }

        const onFailure = err => {
            if (err.message) {
                Notifier.showError(err.message);
            }
        };

        R.handle(R.passport.delete, passports.id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onAssign = () => {
        passportsStore.setRequest(passports, statusComplete);
    }

    const onReturn = () => {
        let data = copyObject(passports);
        data.status = PASSPORT_STATUS.RETURN;
        passportsStore.setRequest(data, statusComplete);
        // Alert.confirm("Επιστροφή διαβατηρίων", `Να γίνει επιστροφή των διαβατηρίων από το μέλος <b>${passports.member.lastname} ${passports.member.firstname}</b>;`, returnPassports);
    }

    const onDestroy = () => {
        Alert.confirm("Καταστροφή διαβατηρίων", `Να γίνει καταστροφή των διαβατηρίων <b>${$passportsStore.prefix}${passports.passport_from}</b> - <b>${$passportsStore.prefix}${passports.passport_to}</b>;`,
            destroyPassports);
    }

    const destroyPassports = () => {
        let data = copyObject(passports);
        data.status = PASSPORT_STATUS.DESTROY;
        passportsStore.setRequest(data, statusComplete);
    }

    const statusComplete = param => {
        if (param.error) {
            passports.error = param.error;
        } else {
            passports = param;
            $passportsStore.changed = true;
            if (!passports.fail) {
                close(passports);
            }
        }
    }

    const close = (param) => {
        passports = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    load();

    // $: {
    //     if (passports) {
    //         passports.total = 0;
    //         if (passports.passport_from && passports.passport_to) {
    //             let dif = parseInt(passports.passport_to) - parseInt(passports.passport_from) + 1;
    //             passports.total += dif;
    //         }
    //     }
    // }
</script>

{#if passports}
    <Modal title="Διαβατήρια" modalSm on:close="{ close }">
        <div slot="body">

            <h5 class="mb-2">{ passports.member.lastname } { passports.member.firstname }</h5>
            <div class="mb-2">
                Α.Φ.Μ.: <span class="text-gray">{ passports.member.afm }</span>
            </div>
            {#if passports.order}
                <div class="mb-2">
                    Κωδικός παραγγελίας: <span class="text-gray">{ passports.order.ref_id }</span>
                </div>
            {/if}
            <div class="passports-row mb-2">
                <div class="form-control passport-number">{ $passportsStore.prefix }{ passports.passport_from }</div>
                <div>-</div>
                <div class="form-control passport-number">{ $passportsStore.prefix }{ passports.passport_to }</div>
            </div>
            <div class="mb-2">
                Σύνολο: <b>{ passports.total }</b>
            </div>
            <div class="mb-2">
                { passportStatus(passports.status) }
                {#if passports.status < 0}
                    <span class="text-info">(δεν έχουν σταλεί)</span>
                {/if}
            </div>
            {#if passports.synced_at}
                <div class="mb-2">
                    Ενημέρωση: <span class="text-gray">{ formatDate(passports.synced_at, 'd-m-y H:i') }</span>
                </div>
            {/if}
            {#if passports.error}
                <div class="mb-2">
                    Σφάλμα: <span class="text-danger">{ passports.error }</span>
                </div>
            {/if}
            {#if passports.fail && passports.fail.length}
                <div class="alert alert-danger px-2 py-2 mt-3 pointer" on:click={ toggleFail }>
                    { passports.fail.length } διαβατήρια με σφάλμα
                </div>
                {#if showFail}
                    <div class="fail-passports">
                        <table class="table table-list table-sm">
                            <tbody>
                            {#each passports.fail as item}
                                <tr>
                                    <td class="ps-0 pe-2 py-2">{ item.passportcode }</td>
                                    <td class="small text-gray line-height-1 ps-2 pe-0 py-2">{ item.statusmessage }</td>
                                </tr>
                            {/each}
                            </tbody>
                        </table>
                    </div>
                {/if}
            {/if}

            {#if passports.status == PASSPORT_STATUS.ASSIGN}
                <div class="row mt-4">
                    <div class="col-6">
                        <button class="btn btn-danger btn-block" on:click={ onDelete }>ΔΙΑΓΡΑΦΗ</button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-primary btn-block" on:click={ onAssign }>ΑΝΑΘΕΣΗ</button>
                    </div>
                </div>
            {/if}
            {#if passports.status == PASSPORT_STATUS.ASSIGNED}
                <div class="row mt-4">
                    <div class="col-6">
                        <button class="btn btn-danger btn-block" on:click={ onDestroy }>ΚΑΤΑΣΤΡΟΦΗ</button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-success btn-block" on:click={ onReturn }>ΕΠΙΣΤΡΟΦΗ</button>
                    </div>
                </div>
            {/if}
            {#if passports.status == PASSPORT_STATUS.RETURN}
                <button class="btn btn-danger btn-block mt-4" on:click={ onReturn }>ΕΠΙΣΤΡΟΦΗ</button>
            {/if}
            {#if passports.status == PASSPORT_STATUS.RETURNED}
                <button class="btn btn-danger btn-block mt-4" on:click={ onDestroy }>ΚΑΤΑΣΤΡΟΦΗ</button>
            {/if}
            <hr>
            <div class="text-end">
                <div class="btn btn-link" on:click="{ () => close() }">Κλείσιμο</div>
            </div>
        </div>
    </Modal>
{/if}

<style>
    .passports-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .passports-row .passport-number {
        width: 46%;
    }

    .fail-passports {
        max-height: 300px;
        overflow-y: auto;
    }
</style>